import {css} from '@emotion/css';
import {Breakpoints, mq, negative} from '@fo/shared/styles/mixins';
import {colours, fonts, spacing} from '@fo/shared/styles/variables';

const styles = {
  container: css`
    label: createAccountTypeModal;

    margin-top: ${spacing.XS};

    ${mq(Breakpoints.TABLET)} {
      margin-top: ${negative(spacing.XXS)};
    }
  `,
  title: css`
    label: createAccountTypeModal__title;
    margin-bottom: ${spacing.S};
  `,
  cardContainer: css`
    label: createAccountTypeModal__cardContainer;

    ${mq(Breakpoints.DESKTOP)} {
      display: flex;
      align-items: stretch;
    }
  `,
  card: css`
    label: createAccountTypeModal__card;
    display: flex;
    border-radius: 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border: solid 1px ${colours.border.LIGHT_GRAY};

    margin-bottom: ${spacing.S};

    ${mq(Breakpoints.DESKTOP)} {
      margin-right: ${spacing.S};
      width: calc(50% - (${spacing.S} / 2));

      &:last-of-type {
        margin-right: 0;
      }
    }
  `,
  cardContent: css`
    label: createAccountTypeModal__cardContent;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  `,
  cardCopy: css`
    label: createAccountTypeModal__cardCopy;
    text-align: ${fonts.alignment.CENTER};
    color: ${colours.font.BLACK};
  `,
  cardButton: css`
    label: createAccountTypeModal__cardButton;
    max-width: 32rem;
    margin: auto;
  `,
};

export default styles;
